module.exports = __webpack_public_path__ + "static/media/tariffImage.3dd35aa4.png";